<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Pilih Grade</h5>
            </b-card-header>
            <b-card-body>
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/grades"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action-slot" slot-scope="props">
                            <button type="button" :disabled="isSelected(props.rowData.id)" title="Pilih" @click="select(props.rowData)" class="btn btn-primary"><i class="fas fa-check"></i> Pilih</button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';

export default {
    name: "grade-selector",

    props: {
        selected: {
            type: Array,
            default: () => [],
        }
    },

    components: {
        SearchBar,
    },

    mixins: [VuetableMixin],

    data() {
        return {
            perPage: 10,
            currentUser: null,
            searchText: '',
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'code',
                    title: 'Kode',
                    sortField: 'code',
                },
                {
                    name: 'name',
                    title: 'Nama',
                    sortField: 'name',
                },
                {
                    name: '__slot:action-slot',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "name", direction: "asc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
            };
        },
    },

    methods: {
        searchSet(searchText) {
            this.searchText = searchText;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.refresh();
        },

        isSelected(id) {
            return this.selected.find(grade => grade.id == id);
        },

        select(data) {
            this.$emit('selected', data);
        },
    },
}
</script>
